export const setACCEPTANCEOBJECT = "setACCEPTANCEOBJECT";
